import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import "../../App.css";
import { Button } from "reactstrap";
import Api from "../api/api";
import MyLoader from "./loader";
import showToast from "./toast";
import { ToastContainer } from "react-toastify";
import back from "../../assets/back.png";

export default (props) => {
  //   var history = useHistory();
  //   let filePath = MyStorage.getFileUrls().LibraryImages;

  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState(
    props.selectedCategories ? props.selectedCategories : []
  );
  const [selectedVideos, setSelectedVideos] = useState(
    props.selectedVideos ? props.selectedVideos : []
  );
  const [showVideos, setShowVideos] = useState(false);

  const [libraryType, setLibraryType] = useState(props.library_type);
  const [models, setModels] = useState([]);
  const [parentCat, setParentCat] = useState(null);
  const [selectedCat, setSelectedCat] = useState(null);
  const [loader, setLoader] = useState(false);

  // load data
  useEffect(() => {
    console.log("useEffect");
    loadData();
  }, []);

  const loadData = () => {
    console.log("loadLibrary: " + libraryType);
    setLoader(true);
    Api.getCategoriesAdmin(
      (response) => {
        setLoader(false);
        if (response.length > 0) {
          let cats = [];
          for (let i = 0; i < response.length; i++) {
            const item = response[i];
            if (item.type === libraryType) {
              cats.push(item);
            }
          }
          setCategories(cats);
          loadSubcategories(cats, parentCat);
        }
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const loadSubcategories = (categories, parentCat) => {
    setTimeout(() => {
      let models = [];
      if (parentCat == null) {
        // load parent categories
        console.log("3");
        models = getParentCats(categories);
        // console.log('categories: ' + categories.length);
        setModels(models);
      } else {
        // load subcategories
        console.log("4");
        const parentId = parentCat.id;
        let subCategories = [];
        for (let i = 0; i < categories.length; i++) {
          const category = categories[i];
          if (category.parent_id + "" === parentId + "") {
            subCategories = subCategories.concat(category);
          }
        }
        // console.log('size: ' + subCategories.length);
        models = subCategories;
        setModels(models);
      }
    }, 50);
  };

  const getParentCats = (cats) => {
    let parentCats = [];
    for (let i = 0; i < cats.length; i++) {
      const cat = cats[i];
      if (cat.parent_id + "" === "0") {
        parentCats = parentCats.concat(cat);
      }
    }
    return parentCats;
  };

  const onCategoryPress = (model) => {
    // check if this category has subcategories
    const parentId = model.id;
    let subCategories = [];
    for (let i = 0; i < categories.length; i++) {
      const category = categories[i];
      if (category.parent_id + "" === parentId + "") {
        subCategories = subCategories.concat(category);
      }
    }

    if (subCategories.length > 0) {
      // load sub categories
      setSelectedCat(model);
      setParentCat(model);
      setModels(subCategories);
    } else {
      // open videos
      if (props.type === "category") return;
      // setSelectedCat(model) // testing
      // setParentCat(model) // testing
      loadVideos(model);
    }
  };

  const loadVideos = (model) => {
    setLoader(true);
    Api.getCategoryVideos(
      model.id,
      (response) => {
        setLoader(false);
        if (response.status === "success") {
          if (response.data.length == 0) {
            showToast("error", "No videos found");
            return;
          }
          setShowVideos(true);
          setModels(response.data);
        }
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const goToParent = () => {
    // console.log('GO BACK');
    if (showVideos) {
      setShowVideos(false);
      setSelectedCat(selectedCat);
      setParentCat(parentCat);
      loadSubcategories(categories, parentCat);
      return;
    }
    let current = parentCat;
    const rootId = current.parent_id + "";
    // console.log('rootId: ' + rootId);
    if (rootId === "0") {
      setSelectedCat(null);
      setParentCat(null);
      let models = getParentCats(categories);
      setModels(models);
      console.log("NULL");
    } else {
      // find parent
      let root = null;
      for (let i = 0; i < categories.length; i++) {
        const category = categories[i];
        if (category.id + "" === rootId) {
          root = category;
        }
      }
      setSelectedCat(root);
      setParentCat(root);
      loadSubcategories(categories, root);
      console.log("NOT NULL");
    }

    setTimeout(() => {
      console.log("onBack parentCat: " + JSON.stringify(parentCat));
    }, 1000);
  };

  const checkSelectedCategory = (model) => {
    for (let i = 0; i < selectedCategories.length; i++) {
      const category = selectedCategories[i];
      if (category.id + "" === model.id + "") {
        return true;
      }
    }
    return false;
  };

  const addSelectedCategory = (model) => {
    let cats = selectedCategories.concat(model);
    setSelectedCategories(cats);
  };

  const removeSelectedCategory = (model) => {
    const cats = selectedCategories.filter((item, j) => {
      return item.id + "" !== model.id + ""; //false will delete
    });
    setSelectedCategories(cats);
  };

  const checkSelectedVideo = (model) => {
    for (let i = 0; i < selectedVideos.length; i++) {
      const video = selectedVideos[i];
      if (video.id + "" === model.id + "") {
        return true;
      }
    }
    return false;
  };

  const addSelectedVideo = (model) => {
    let videos = selectedVideos.concat(model);
    setSelectedVideos(videos);
  };

  const removeSelectedVideo = (model) => {
    const videos = selectedVideos.filter((item, j) => {
      return item.id + "" !== model.id + ""; //false will delete
    });
    setSelectedVideos(videos);
  };

  const showCategoryItem = (model, index) => {
    // console.log('showCategoryItem type: ' + props.type);
    let className =
      index % 2 !== 0 ? "projects-itembar" : "projects-itembar-colored";
    return (
      <div
        className="item-btn"
        style={{ display: "flex", flexDirection: "column", width: 400 }}
        onClick={(event) => {
          // console.log('click');
          onCategoryPress(model);
        }}
      >
        <div className={className} style={{ marginTop: 0 }}>
          {/* <div className='projects-item-photo'>
                        <img src={filePath + model.image} style={{ padding: 1, width: 70, height: 70, objectFit: 'cover' }} />
                    </div> */}
          <div className="projects-item-cat" style={{}}>
            <div style={{ fontSize: 16 }}>{model.title}</div>
          </div>

          {props.type === "video" ? null : (
            <div
              className="projects-item-cat"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <input
                style={{ width: 20, height: 20 }}
                type="checkbox"
                checked={checkSelectedCategory(model)}
                onChange={(event) => {
                  console.log(JSON.stringify(event.target.value));
                  if (checkSelectedCategory(model)) {
                    removeSelectedCategory(model);
                  } else {
                    addSelectedCategory(model);
                  }
                }}
                onClick={(event) => {
                  event.stopPropagation();
                }}
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  const showVideoItem = (model, index) => {
    console.log("showVideoItem type: " + props.type);
    let className =
      index % 2 !== 0 ? "projects-itembar" : "projects-itembar-colored";
    return (
      <div
        className="item-btn"
        style={{ display: "flex", flexDirection: "column", width: 400 }}
        onClick={(event) => {
          // console.log('click');
          // onCategoryPress(model)
        }}
      >
        <div className={className} style={{ marginTop: 0 }}>
          <div className="projects-item-photo">
            <img
              src={model.thumbnail}
              style={{ padding: 1, width: 70, height: 70, objectFit: "cover" }}
            />
          </div>
          <div className="projects-item-cat" style={{}}>
            <div style={{ fontSize: 16 }}>{model.title}</div>
          </div>
          <div
            className="projects-item-cat"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <input
              style={{ width: 20, height: 20 }}
              type="checkbox"
              checked={checkSelectedVideo(model)}
              onChange={(event) => {
                console.log(JSON.stringify(event.target.value));
                if (checkSelectedVideo(model)) {
                  removeSelectedVideo(model);
                } else {
                  addSelectedVideo(model);
                }
              }}
              onClick={(event) => {
                event.stopPropagation();
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Popup
      contentStyle={{ width: 500, height: 500 }}
      trigger={props.button}
      modal
      nested
    >
      {(close) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: 0,
            height: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              height: 45,
              width: "100%",
              backgroundColor: "gray",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div style={{ fontSize: 18, fontWeight: "bold", color: "white" }}>
              {props.title}
            </div>
          </div>
          <div
            style={{
              overflow: "scroll",
              padding: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div style={{ marginTop: 15, height: 350 }}>
              {parentCat == null ? null : (
                <img
                  onClick={() => {
                    // console.log('click');
                    goToParent();
                  }}
                  src={back}
                  style={{
                    width: 30,
                    height: 30,
                    marginTop: 10,
                    marginRight: 10,
                  }}
                  className="icon-btn"
                />
              )}

              <div style={{ marginTop: 10 }}></div>

              {models.map((model, index) => {
                // console.log('url: ' + (filePath + model.image));
                if (!showVideos) {
                  return showCategoryItem(model, index);
                } else {
                  return showVideoItem(model, index);
                }
              })}
            </div>
          </div>

          <div
            style={{
              padding: 10,
              display: "flex",
              flex: 1,
              alignItems: "flex-end",
            }}
          >
            <Button
              className="btn-block"
              style={{
                backgroundColor: "green",
                borderWidth: 0,
                width: "50%",
                height: 40,
                fontWeight: "bold",
                fontSize: 16,
              }}
              onClick={() => {
                console.log("click");
                if (props.type === "category") props.onDone(selectedCategories);
                else props.onDone(selectedVideos);
                close();
              }}
            >
              Done
            </Button>
            <Button
              className="btn-block"
              style={{
                marginLeft: 15,
                backgroundColor: "red",
                borderWidth: 0,
                width: "50%",
                height: 40,
                fontWeight: "bold",
                fontSize: 16,
              }}
              onClick={() => {
                console.log("click");
                close();
              }}
            >
              Cancel
            </Button>
          </div>

          <MyLoader loader={loader} />
          <div>
            <ToastContainer />
          </div>
        </div>
      )}
    </Popup>
  );
};
